import React from 'react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-102" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-2xl" data-id="element-103" data-mp="1r4ixbfyqivnc">
        <h2 className="text-center font-heading text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.8rem]" data-id="element-104" data-mp="1vxc3m89uqc1j">
          What's included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-105" data-mp="20vdkcmjt1z9u">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-106" data-mp="146xraghhl7rz">
              <div className="flex items-center gap-1.5 bg-navy px-2.5 py-1.5" data-id="element-107" data-mp="1d6ubo5wufkh8">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-108" data-mp="1d8xclkzjay0q">
                  ✅
                </span>
                <h3 className="font-body text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.88rem]" data-id="element-109" data-mp="2olzpo62fd5g5">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-110" data-mp="1trtxls2sqd4">
                <p className="text-[0.78rem] leading-[1.35] text-graphite sm:text-[0.92rem]" data-id="element-111" data-mp="1sqhbcvevvta">
                  {mod.body}
                </p>
                <p className="mt-1 font-body text-[0.68rem] font-bold uppercase tracking-wide text-teal sm:text-[0.8rem]" data-id="element-112" data-mp="3oypttl4xuc3v">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}